/* AVRA theme interactions — reveal/header/menu/drawer/cart/search/welcome.
   Cart talks to Shopify's classic AJAX Cart API (/cart/add.js, /cart/change.js, /cart.js)
   per the build brief — no Storefront API, no framework. */
(function () {
  'use strict';

  var routes = (window.Theme && window.Theme.routes) || {};
  var CART_JS_URL = (routes.cart_url || '/cart') + '.js';
  var CART_ADD_URL = routes.cart_add_url || '/cart/add.js';
  var CART_CHANGE_URL = (routes.cart_change_url || '/cart/change') + '.js';
  var PREDICTIVE_SEARCH_URL = (routes.predictive_search_url || '/search/suggest') + '.json';

  /* ---- reveal on scroll ---- */
  function initReveal() {
    var root = document.documentElement;
    var els = document.querySelectorAll('.reveal, .clip');
    if (!('IntersectionObserver' in window) || !els.length) { root.classList.add('no-anim'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- header: solid on scroll ---- */
  function initHeader() {
    var head = document.querySelector('.head');
    if (!head) return;
    var on = false;
    function check() {
      var solid = window.scrollY > 40;
      if (solid !== on) { on = solid; head.classList.toggle('solid', solid); }
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
  }

  /* ---- SHOP mega-menu ---- */
  function initMega() {
    var item = document.querySelector('[data-mega]');
    var panel = document.querySelector('[data-mega-panel]');
    var head = document.querySelector('.head');
    if (!item || !panel || !head) return;
    var trigger = item.querySelector('.nav__trigger');
    var closeTimer;

    function open() {
      clearTimeout(closeTimer);
      head.classList.add('mega-open');
      panel.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      head.classList.remove('mega-open');
      panel.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    function scheduleClose() { closeTimer = setTimeout(close, 140); }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        if (window.innerWidth <= 880) return;
        e.preventDefault();
        head.classList.contains('mega-open') ? close() : open();
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // Below 880px the panel is display:none, but .mega-open still restyles the
    // header bar (taller, shadow, border, shifted padding). Reset on resize so a
    // menu opened on desktop cannot leave the mobile header stuck open.
    window.addEventListener('resize', function () { if (window.innerWidth <= 880) close(); }, { passive: true });
  }

  /* ---- mobile drawer ---- */
  function initDrawer() {
    var burger = document.querySelector('.burger');
    var drawer = document.querySelector('.navdrawer');
    if (!burger || !drawer) return;
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    function toggle(open) {
      drawer.classList.toggle('open', open);
      burger.classList.toggle('x', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    burger.addEventListener('click', function () { toggle(!drawer.classList.contains('open')); });
    if (closeBtn) closeBtn.addEventListener('click', function () { toggle(false); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) toggle(false); });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { toggle(false); }); });
  }

  /* ---- accordion (promise / FAQ rows) ---- */
  function initAccordion() {
    document.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('[data-accordion-row]');
        if (!row) return;
        var panel = row.querySelector('[data-accordion-panel]');
        var open = row.classList.toggle('open');
        if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---- carousel arrows ---- */
  function updateCarrowState(wrap) {
    var track = wrap.querySelector('.carousel');
    if (!track) return;
    var prevBtns = wrap.querySelectorAll('[data-car-prev]');
    var nextBtns = wrap.querySelectorAll('[data-car-next]');
    var maxScroll = track.scrollWidth - track.clientWidth;
    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft >= maxScroll - 2;
    prevBtns.forEach(function (b) { b.disabled = atStart; });
    nextBtns.forEach(function (b) { b.disabled = maxScroll <= 2 || atEnd; });
  }

  /* one dot per card; active dot = card closest to current scroll position */
  /* one dot per real scroll "page" (however many cards fit in one view),
     not one per card — a page-count mismatch left dead dots at the end
     that the carousel could never actually scroll to. */
  function initCarouselDots(wrap) {
    var track = wrap.querySelector('.carousel');
    var dotsEl = wrap.querySelector('[data-dots]');
    if (!track || !dotsEl) return;

    var dots = [];
    var pages = 0;

    function sync() {
      if (!pages) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var idx;
      if (maxScroll <= 1) {
        idx = 0;
      } else if (track.scrollLeft >= maxScroll - 2) {
        /* snap to the last dot at the true end of scroll, even if the
           final page doesn't advance a full clientWidth */
        idx = pages - 1;
      } else {
        idx = Math.round((track.scrollLeft / maxScroll) * (pages - 1));
        idx = Math.min(Math.max(idx, 0), pages - 1);
      }
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }

    function build() {
      /* the track's own direct children are the slides, whatever they are
         (.prod cards, .cat tiles, ...) — no need to hardcode a class */
      var cards = Array.prototype.slice.call(track.children);
      dotsEl.innerHTML = '';
      dots = [];
      pages = 0;
      if (!cards.length) return;
      /* real per-card advance (card width + gap), measured from the DOM
         so it stays accurate across breakpoints instead of assumed */
      var advance = cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : cards[0].offsetWidth;
      if (!advance) advance = cards[0].offsetWidth || 1;
      var perView = Math.max(1, Math.round(track.clientWidth / advance));
      pages = Math.max(1, Math.ceil(cards.length / perView));
      for (var i = 0; i < pages; i++) {
        (function (pageIndex) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cardots__dot';
          b.setAttribute('aria-label', 'Go to slide ' + (pageIndex + 1));
          b.addEventListener('click', function () {
            var card = cards[Math.min(pageIndex * perView, cards.length - 1)];
            track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          });
          dotsEl.appendChild(b);
          dots.push(b);
        })(i);
      }
      sync();
    }

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', build, { passive: true });
    build();
  }

  /* Wires one [data-carousel] wrap for arrows/dots/drag/touch-swipe. Called
     for every carousel present at load, and again for any carousel markup
     inserted later (e.g. the bag drawer's recommendations), since that
     content doesn't exist yet when initCarousels() first runs. */
  function wireCarousel(wrap) {
      var track = wrap.querySelector('.carousel');
      if (!track) return;
      wrap.querySelectorAll('[data-car-prev]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.86, behavior: 'smooth' }); });
      });
      wrap.querySelectorAll('[data-car-next]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.86, behavior: 'smooth' }); });
      });
      track.addEventListener('scroll', function () { updateCarrowState(wrap); }, { passive: true });
      updateCarrowState(wrap);
      initCarouselDots(wrap);

      /* click-and-drag on desktop, and finger-drag on touch. The track has
         touch-action:pan-y (so a vertical swipe over the carousel always
         reaches the page instead of getting stuck — see the axis-lock
         below) — but that CSS value also switches OFF the browser's own
         native horizontal panning for this element entirely, so nothing
         is left to scroll it sideways on touch unless this handler does
         it. Same pointer code drives both mouse and touch; the axis-lock
         is what keeps a vertical touch gesture free to fall through to
         native page scroll. */
      var dragging = false, decided = false, horizontal = false;
      var startX = 0, startY = 0, startScroll = 0, dragDistance = 0;
      var AXIS_LOCK_PX = 5; /* movement needed before committing to an axis */
      /* a real drag happened (either axis) — swallow the ghost "click"
         that follows this release so it doesn't also navigate. */
      function suppressNextClick() {
        track.addEventListener('click', function suppress(e) {
          e.preventDefault();
          e.stopPropagation();
        }, { capture: true, once: true });
      }
      function snapToNearest() {
        var cards = Array.prototype.slice.call(track.children);
        if (!cards.length) return;
        var sl = track.scrollLeft, best = cards[0], bestD = Infinity;
        cards.forEach(function (card) {
          var d = Math.abs((card.offsetLeft - track.offsetLeft) - sl);
          if (d < bestD) { bestD = d; best = card; }
        });
        track.scrollTo({ left: best.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      /* .prod__media / .prod__info are real <a> tags, and anchors are
         natively draggable — a real mouse click almost always has a
         pixel or two of jitter, enough to cross the browser's own
         drag-initiation threshold and fire a native dragstart. That
         hijacks the gesture before our pointermove ever runs a second
         time (scrollLeft never moves) and swallows the click that would
         otherwise follow (so the card never navigates either). Cancel it
         so our own pointer handling is the only thing driving this. */
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      /* Mouse only from here — real touch input is handled below with
         native touchstart/touchmove/touchend, not Pointer Events. Chrome
         and Safari both also fire pointer events for touch, but relying
         on them for the drag itself proved unreliable on real phones
         (setPointerCapture + touch-action interactions differ enough
         across mobile browsers that the gesture would silently drop),
         so touch drives scrollLeft directly through TouchEvent instead. */
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        dragging = true;
        decided = false;
        horizontal = false;
        startX = e.clientX;
        startY = e.clientY;
        startScroll = track.scrollLeft;
        dragDistance = 0;
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!decided) {
          /* wait for a few px of real movement before committing to an
             axis — avoids locking onto a direction from a single jittery
             sample */
          if (Math.abs(dx) < AXIS_LOCK_PX && Math.abs(dy) < AXIS_LOCK_PX) return;
          decided = true;
          horizontal = Math.abs(dx) > Math.abs(dy);
          if (!horizontal) {
            dragging = false;
            suppressNextClick();
            return;
          }
          track.classList.add('dragging');
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (!horizontal) return;
        dragDistance = Math.max(dragDistance, Math.abs(dx));
        track.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('dragging');
        if (dragDistance > 6) suppressNextClick();
        snapToNearest();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      /* Touch — real TouchEvent listeners, axis-locked the same way as
         the mouse path above. touchmove MUST be { passive: false } or
         preventDefault() inside it is a no-op; we only call it once the
         gesture is confirmed horizontal, so a vertical finger drag is
         never intercepted and always reaches native page scroll. */
      var tActive = false, tDecided = false, tHorizontal = false;
      var tStartX = 0, tStartY = 0, tStartScroll = 0;
      track.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        tActive = false; /* AVRA: native touch scrolling — JS drag disabled on touch, browser handles scrollLeft/momentum via touch-action:pan-x */
        tDecided = false;
        tHorizontal = false;
        tStartX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tStartScroll = track.scrollLeft;
      }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (!tActive) return;
        var t = e.touches[0];
        var dx = t.clientX - tStartX;
        var dy = t.clientY - tStartY;
        if (!tDecided) {
          if (Math.abs(dx) < AXIS_LOCK_PX && Math.abs(dy) < AXIS_LOCK_PX) return;
          tDecided = true;
          tHorizontal = Math.abs(dx) > Math.abs(dy);
          if (!tHorizontal) {
            /* vertical gesture — release it completely and let the page
               scroll natively; never preventDefault, never touch scrollLeft */
            tActive = false;
            return;
          }
          track.classList.add('dragging');
        }
        if (!tHorizontal) return;
        e.preventDefault();
        track.scrollLeft = tStartScroll - dx;
      }, { passive: false });
      function endTouch() {
        if (!tActive) return;
        tActive = false;
        track.classList.remove('dragging');
        snapToNearest();
      }
      track.addEventListener('touchend', endTouch);
      track.addEventListener('touchcancel', endTouch);
  }

  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(wireCarousel);
  }

  /* ---- favorites (client-side, localStorage) ---- */
  var FAV_KEY = 'avra:favorites';
  function loadFavs() { try { return JSON.parse(localStorage.getItem(FAV_KEY)) || {}; } catch (e) { return {}; } }
  function saveFavs(f) { try { localStorage.setItem(FAV_KEY, JSON.stringify(f)); } catch (e) {} }

  function renderFavCount() {
    var n = Object.keys(loadFavs()).length;
    document.querySelectorAll('[data-fav-n]').forEach(function (el) {
      el.hidden = n === 0;
      el.textContent = n;
    });
    document.querySelectorAll('[data-fav-open]').forEach(function (el) {
      el.classList.toggle('has', n > 0);
    });
  }

  function syncHeartState(handle, isFav) {
    document.querySelectorAll('[data-product-handle="' + handle + '"] .prod__fav').forEach(function (btn) {
      btn.classList.toggle('on', isFav);
      btn.setAttribute('aria-pressed', isFav ? 'true' : 'false');
    });
  }

  function getCardFavData(card) {
    /* the PDP heart lives on a totally different markup shape than a
       .prod card (h1/price/img ids instead of card classes) */
    if (card.hasAttribute('data-pdp')) {
      var pdpImg = card.querySelector('#pdp-media-img');
      var variantInput = card.querySelector('[data-pdp-variant-input]');
      return {
        handle: card.getAttribute('data-product-handle'),
        url: window.location.pathname,
        title: card.querySelector('[data-pdp-name]') ? card.querySelector('[data-pdp-name]').textContent.trim() : '',
        price: card.querySelector('[data-pdp-price]') ? card.querySelector('[data-pdp-price]').textContent.trim() : '',
        image: pdpImg ? pdpImg.getAttribute('src') : '',
        variantId: variantInput ? variantInput.value : null,
      };
    }
    var nameEl = card.querySelector('.prod__name');
    var priceEl = card.querySelector('.prod__price');
    var img = card.querySelector('image-slot img');
    var quickAdd = card.querySelector('[data-quick-add]');
    return {
      handle: card.getAttribute('data-product-handle'),
      url: nameEl ? nameEl.getAttribute('href') : '#',
      title: nameEl ? nameEl.textContent.trim() : '',
      price: priceEl ? priceEl.textContent.trim() : '',
      image: img ? img.getAttribute('src') : '',
      variantId: quickAdd ? quickAdd.getAttribute('data-quick-add') : null,
    };
  }

  function renderFavDrawer() {
    var body = document.querySelector('[data-fav-body]');
    if (!body) return;
    var favs = loadFavs();
    var items = Object.keys(favs).map(function (h) { return favs[h]; });

    if (!items.length) {
      body.innerHTML =
        '<div class="bagempty">' +
          '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 20S4 14.7 4 9.1A4.1 4.1 0 0 1 12 6.8 4.1 4.1 0 0 1 20 9.1C20 14.7 12 20 12 20Z"/></svg>' +
          '<p>No saved pieces yet. Tap the heart on anything you love.</p>' +
          '<a href="' + (routes.all_products_collection_url || '/collections/all') + '" class="btn btn--pill" data-fav-close>Shop All</a>' +
        '</div>';
      return;
    }

    body.innerHTML = items.map(function (item) {
      return (
        '<div class="favitem">' +
          '<a href="' + item.url + '" class="favitem__thumb" data-fav-close>' + (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="favitem__info">' +
            '<a href="' + item.url + '" class="favitem__name" data-fav-close>' + item.title + '</a>' +
            '<span class="favitem__price">' + item.price + '</span>' +
            '<div class="favitem__actions">' +
              (item.variantId ? '<button type="button" class="favitem__add" data-quick-add="' + item.variantId + '">Add to bag</button>' : '') +
              '<button type="button" class="favitem__rm" data-fav-remove="' + item.handle + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function initFavorites() {
    renderFavCount();
    var favs = loadFavs();
    Object.keys(favs).forEach(function (handle) { syncHeartState(handle, true); });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.prod__fav');
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest('[data-product-handle]');
      var handle = card ? card.getAttribute('data-product-handle') : null;
      if (!handle) return;
      var favs = loadFavs();
      var wasFav = !!favs[handle];
      if (wasFav) {
        delete favs[handle];
      } else {
        favs[handle] = getCardFavData(card);
        btn.classList.add('pop');
        setTimeout(function () { btn.classList.remove('pop'); }, 450);
      }
      saveFavs(favs);
      syncHeartState(handle, !wasFav);
      renderFavCount();
      renderFavDrawer();
    });
  }

  function initFavDrawer() {
    var drawer = document.querySelector('[data-fav-drawer]');
    if (!drawer) return;

    function open() {
      renderFavDrawer();
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-fav-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) { close(); return; }
      if (e.target.closest('[data-fav-close]')) { close(); return; }

      var rmBtn = e.target.closest('[data-fav-remove]');
      if (rmBtn) {
        var handle = rmBtn.getAttribute('data-fav-remove');
        var favs = loadFavs();
        delete favs[handle];
        saveFavs(favs);
        syncHeartState(handle, false);
        renderFavCount();
        renderFavDrawer();
      }
    });
  }

  /* ==================================================================
     CART DRAWER — Shopify AJAX Cart API
     ================================================================== */
  var GIFTWRAP_KEY = 'avra:giftwrap';
  var GIFTWRAP_VARIANT_ID = 46224391503929; /* the real "Gift Wrapping" $15 product/variant */
  var GIFTWRAP_FREE_THRESHOLD = 175000; /* $1,750 in cents */
  /* AVRA_GIFTWRAP_OFF - the $15 product is a draft, so gift wrapping is
     switched off at source. Returning false here also neutralises the flag
     already sitting in the browsers of anyone who ticked the box before. */
  function giftWrapOn() { return false; }
  function setGiftWrap(on) { try { localStorage.setItem(GIFTWRAP_KEY, on ? '1' : '0'); } catch (e) {} }
  function giftWrapLineIndex(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === GIFTWRAP_VARIANT_ID) return i;
    }
    return -1;
  }
  /* free at $1,750+ of MERCHANDISE — the wrap fee itself never counts
     toward its own free threshold */
  function giftWrapQualifiesFree(cart) {
    var idx = giftWrapLineIndex(cart);
    var subtotal = cart.total_price;
    if (idx !== -1) subtotal -= cart.items[idx].line_price;
    return subtotal >= GIFTWRAP_FREE_THRESHOLD;
  }

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function fetchCart() {
    return fetch(CART_JS_URL, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function renderBagItem(item, index) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy">' : '';
    return (
      '<div class="bagitem" data-line="' + (index + 1) + '">' +
        '<div class="bagitem__thumb">' + img + '</div>' +
        '<div class="bagitem__info">' +
          '<span class="bagitem__name">' + item.product_title + '</span>' +
          (item.variant_title ? '<span class="bagitem__desc">' + item.variant_title + '</span>' : '') +
          '<span class="bagitem__price">' + money(item.final_line_price) + '</span>' +
          '<div class="bagitem__row">' +
            '<span class="bagqty">' +
              '<button type="button" data-bag-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="bagqty__n">' + item.quantity + '</span>' +
              '<button type="button" data-bag-qty="1" aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<button type="button" class="bagitem__rm" data-bag-remove>Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderBag(cart) {
    var body = document.querySelector('[data-bag-body]');
    var foot = document.querySelector('[data-bag-foot]');
    if (!body || !foot) return;

    /* if a qty/remove/add-to-cart change moved the merchandise subtotal
       across the $1,750 line since gift wrap was last toggled, the $15
       fee line is now stale (charged when it should be free, or vice
       versa) — reconcile before rendering rather than showing it wrong */
    if (giftWrapOn() && cart.items.length) {
      var free = giftWrapQualifiesFree(cart);
      var giftIdx = giftWrapLineIndex(cart);
      var stale = (free && giftIdx !== -1) || (!free && giftIdx === -1);
      if (stale) { applyGiftWrapToCart(true); return; }
    }

    document.querySelectorAll('[data-cart-n]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="bagempty">' +
          '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 20S4 14.7 4 9.1A4.1 4.1 0 0 1 12 6.8 4.1 4.1 0 0 1 20 9.1C20 14.7 12 20 12 20Z"/></svg>' +
          '<p>Your bag is empty. Discover a piece worth keeping.</p>' +
          '<a href="/collections/all" class="btn btn--pill" data-bag-close>Shop All</a>' +
        '</div>';
      foot.innerHTML = '';
      return;
    }

    var giftFree = giftWrapQualifiesFree(cart);
    body.innerHTML =
      cart.items.filter(function (item) { return item.variant_id !== GIFTWRAP_VARIANT_ID; }).map(renderBagItem).join('') +
      '<div class="bagrecs" data-bag-recs></div>';

    foot.innerHTML =
      '<div class="bagsum">' +
        '<div class="bagsum__row"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<div class="bagsum__row"><span>Shipping</span><span>Calculated at checkout</span></div>' +
      '</div>' +
      '<button type="button" class="btn btn--solid bagcheckout" data-bag-checkout>Checkout</button>' +
      '<p class="bagnote">20-business-day returns for store credit</p>';

    var merch = cart.items.filter(function (item) { return item.variant_id !== GIFTWRAP_VARIANT_ID; });
    if (merch.length) loadRecommendations(merch[merch.length - 1].product_id);
  }

  function loadRecommendations(productId) {
    var mount = document.querySelector('[data-bag-recs]');
    if (!mount || !productId) return;
    /* "complementary" needs real order history to have anything to recommend
       from, which this store doesn't have pre-launch yet (comes back empty).
       "related" uses catalog/tag similarity and works immediately — same
       intent the PDP's own recommendations carousel already uses. */
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) { return p.available; });
        if (!products.length) return;
        mount.innerHTML =
          '<p class="bagrecs__h">Pairs beautifully</p>' +
          '<div class="bagrecs__car" data-carousel>' +
            '<div class="carousel">' +
              products.map(function (p) {
                var img = p.featured_image || (p.images && p.images[0]);
                var price = p.price_varies ? 'From ' + money(p.price) : money(p.price);
                return (
                  '<article class="prod">' +
                    '<a href="' + p.url + '" class="prod__media">' +
                      '<image-slot>' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</image-slot>' +
                      '<button type="button" class="prod__quick" data-quick-add="' + p.variants[0].id + '" onclick="event.preventDefault();">Add to bag</button>' +
                    '</a>' +
                    '<a href="' + p.url + '" class="prod__info">' +
                      '<span class="prod__name">' + p.title + '</span>' +
                      '<span class="prod__price">' + price + '</span>' +
                    '</a>' +
                  '</article>'
                );
              }).join('') +
            '</div>' +
          '</div>';
        wireCarousel(mount.querySelector('[data-carousel]'));
      })
      .catch(function () {});
  }

  function openBag() {
    var drawer = document.querySelector('[data-bag-drawer]');
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart().then(renderBag);
  }
  function closeBag() {
    var drawer = document.querySelector('[data-bag-drawer]');
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function applyGiftWrapToCart(on) {
    setGiftWrap(on);
    fetchCart().then(function (cart) {
      var free = giftWrapQualifiesFree(cart);
      var giftIdx = giftWrapLineIndex(cart);

      /* tag/untag merchandise lines first, using their original indices —
         these stay valid until the gift-wrap line itself is added/removed
         below (removal re-indexes the cart, so it has to happen last) */
      var chain = Promise.resolve();
      cart.items.forEach(function (item, i) {
        if (item.variant_id === GIFTWRAP_VARIANT_ID) return;
        chain = chain.then(function () {
          var props = Object.assign({}, item.properties || {});
          if (on && free) props['Gift wrapping'] = 'Complimentary'; else delete props['Gift wrapping'];
          return fetch(CART_CHANGE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: i + 1, quantity: item.quantity, properties: props }),
          });
        });
      });

      if (on && !free && giftIdx === -1) {
        /* below the free threshold and not already added — charge the $15 */
        chain = chain.then(function () {
          return fetch(CART_ADD_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: GIFTWRAP_VARIANT_ID, quantity: 1 }),
          });
        });
      } else if ((!on || free) && giftIdx !== -1) {
        /* unchecked, or the cart grew past the free threshold — drop the fee */
        chain = chain.then(function () {
          return fetch(CART_CHANGE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: giftIdx + 1, quantity: 0 }),
          });
        });
      }

      return chain;
    }).then(fetchCart).then(renderBag);
  }

  function addToCart(variantId, quantity, extraProps) {
    var properties = Object.assign({}, extraProps || {});
    if (giftWrapOn()) properties['Gift wrapping'] = 'Complimentary';
    return fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1, properties: properties }),
    }).then(function (r) { return r.json(); });
  }

  function initCart() {
    document.querySelectorAll('[data-bag-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openBag(); });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-bag-close]')) { closeBag(); return; }
      var drawer = document.querySelector('[data-bag-drawer]');
      if (drawer && drawer.classList.contains('open') && e.target === drawer) closeBag();

      var qtyBtn = e.target.closest('[data-bag-qty]');
      if (qtyBtn) {
        var line = qtyBtn.closest('[data-line]').getAttribute('data-line');
        var delta = parseInt(qtyBtn.getAttribute('data-bag-qty'), 10);
        var current = parseInt(qtyBtn.closest('.bagitem__row').querySelector('.bagqty__n').textContent, 10);
        var next = Math.max(0, current + delta);
        fetch(CART_CHANGE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: next }),
        }).then(fetchCart).then(renderBag);
      }

      var rmBtn = e.target.closest('[data-bag-remove]');
      if (rmBtn) {
        var rline = rmBtn.closest('[data-line]').getAttribute('data-line');
        fetch(CART_CHANGE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: rline, quantity: 0 }),
        }).then(fetchCart).then(renderBag);
      }

      var checkoutBtn = e.target.closest('[data-bag-checkout]');
      if (checkoutBtn) { window.location.href = '/checkout'; }

      var quickAdd = e.target.closest('[data-quick-add]');
      if (quickAdd) {
        e.preventDefault();
        addToCart(quickAdd.getAttribute('data-quick-add'), 1).then(function () {
          fetchCart().then(renderBag);
        });
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-giftwrap-toggle]')) applyGiftWrapToCart(e.target.checked);
    });

    /* product/quick-add forms */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var variantId = form.querySelector('[name="id"]').value;
      var qtyField = form.querySelector('[name="quantity"]');
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
      addToCart(variantId, qtyField ? parseInt(qtyField.value, 10) || 1 : 1, (function () { /* AVRA_PERSONALISATION */ var p = {}; form.querySelectorAll('[name^="properties["]').forEach(function (f) { var m = /^properties\[(.+)\]$/.exec(f.getAttribute('name') || ''); if (m && f.value && f.value.trim()) p[m[1]] = f.value.trim(); }); return p; })())
        .then(function (res) {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          if (res.status === 422) { alert(res.description || 'This item could not be added.'); return; }
          openBag();
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        });
    });
  }

  /* whole catalog, fetched once and cached — the store is small enough
     that searching titles client-side is simpler and more reliable than
     Shopify's predictive search relevance scoring (see initSearch). */
  var allProductsCache = null;
  function getAllProducts() {
    if (allProductsCache) return Promise.resolve(allProductsCache);
    return fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        allProductsCache = data.products || [];
        return allProductsCache;
      })
      .catch(function () { return []; });
  }

  /* ==================================================================
     PREDICTIVE SEARCH OVERLAY
     ================================================================== */
  function initSearch() {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;
    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var browse = overlay.querySelector('[data-search-browse]');
    var timer;

    function open() {
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input && input.focus(); }, 50);
    }
    function close() {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    overlay.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var form = overlay.querySelector('[data-search-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = (input.value || '').trim();
        if (!q) return;
        fetch(PREDICTIVE_SEARCH_URL + '?q=' + encodeURIComponent(q) + '&resources[type]=collection&resources[limit]=1')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var cols = (data.resources && data.resources.results && data.resources.results.collections) || [];
            if (cols.length && cols[0].url) {
              window.location.href = cols[0].url;
            } else {
              window.location.href = (routes.search_url || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
            }
          })
          .catch(function () {
            window.location.href = (routes.search_url || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
          });
      });
    }

    if (!input) return;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (!q) {
        if (results) results.innerHTML = '';
        if (browse) browse.hidden = false;
        return;
      }
      if (browse) browse.hidden = true;
      timer = setTimeout(function () {
        /* Shopify's predictive search API still ranks on tags/type/body regardless
           of the "fields" param (it only affects relevance weighting, not what's
           eligible to match), which surfaced e.g. necklaces tagged "cat-bracelets"
           for a "Bracelets" search, and dropped genuine title matches like
           "Versatile Ring" from a "Rings" search entirely. The catalog here is
           small, so search the real title of every product directly instead of
           trusting Shopify's relevance scoring. */
        getAllProducts().then(function (all) {
            var needle = q.toLowerCase().replace(/s$/, '');
            var products = all.filter(function (p) {
              return p.title.toLowerCase().indexOf(needle) !== -1;
            }).slice(0, 8);
            if (!results) return;
            if (!products.length) {
              results.innerHTML = '<p class="search__empty">No results for &ldquo;' + q + '&rdquo;</p>';
              return;
            }
            results.innerHTML = products.map(function (p) {
              var img = p.images && p.images[0] ? p.images[0].src : '';
              var prices = p.variants.map(function (v) { return Number(v.price); });
              var minPrice = Math.min.apply(null, prices);
              var priceLabel = (prices.length > 1 && Math.max.apply(null, prices) !== minPrice ? 'From ' : '') +
                '$' + minPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              return (
                '<a class="sresult" href="/products/' + p.handle + '">' +
                  '<div class="sresult__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="sresult__glyph">A</span>') + '</div>' +
                  '<span class="sresult__cat">' + (p.product_type || '') + '</span>' +
                  '<span class="sresult__name">' + p.title + '</span>' +
                  '<span class="sresult__price">' + priceLabel + '</span>' +
                '</a>'
              );
            }).join('');
          });
      }, 220);
    });
  }

  /* ---- collection filter (category chips + price/material panel) ---- */
  /* ---- collection chips — verbatim port of v0-source avra.js initFilters() ---- */
  function initCollectionChips() {
    var grid = document.querySelector('[data-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.prod'));
    var countEl = document.querySelector('[data-count]');

    function applyFilter(cat) {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = cat === 'all' || (c.getAttribute('data-cat') || '').split(' ').indexOf(cat) !== -1;
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown;
      return shown;
    }

    function selectCat(cat) {
      var chip = document.querySelector('[data-filter="' + cat + '"]');
      document.querySelectorAll('[data-filter]').forEach(function (c) { c.classList.remove('active'); });
      if (chip) chip.classList.add('active');
      var shown = applyFilter(cat);
      if (shown === 0) {
        var all = document.querySelector('[data-filter="all"]');
        document.querySelectorAll('[data-filter]').forEach(function (c) { c.classList.remove('active'); });
        if (all) all.classList.add('active');
        applyFilter('all');
      }
    }

    document.querySelectorAll('[data-filter]').forEach(function (chip) {
      chip.addEventListener('click', function () { selectCat(chip.getAttribute('data-filter')); });
    });
  }

  /* ---- advanced filter panel — verbatim port of v0-source avra-shop-bridge.js ---- */
  var CAT_LABELS = { rings: 'Rings', necklaces: 'Necklaces', earrings: 'Earrings', bracelets: 'Bracelets', bangles: 'Bangles', tennis: 'Tennis' };
  var CAT_ORDER = ['rings', 'necklaces', 'earrings', 'bracelets', 'bangles', 'tennis'];
  var MATERIAL_LABELS = { gold: '14k Gold', vermeil: 'Gold Vermeil', 'lab-grown': 'Lab-Grown Diamond', natural: 'Natural Diamond', emerald: 'Emerald' };
  var MATERIAL_ORDER = ['gold', 'lab-grown', 'natural', 'emerald', 'vermeil'];
  var PRICE_DEFS = [
    { id: 'u500', label: 'Under $500', min: 0, max: 500 },
    { id: '500-1000', label: '$500 – $1,000', min: 500, max: 1000 },
    { id: '1000-2500', label: '$1,000 – $2,500', min: 1000, max: 2500 },
    { id: '2500', label: '$2,500 +', min: 2500, max: Infinity },
  ];

  function initFilterPanel() {
    var grid = document.querySelector('[data-grid]');
    var trigger = document.querySelector('.toolfilter');
    if (!grid || !trigger) return;

    var countEl = document.querySelector('[data-count]');
    var state = { cats: {}, mats: {}, price: null };
    var panel = null;

    function cards() { return Array.prototype.slice.call(grid.querySelectorAll('.prod')); }
    function tokens(el, attr) { return (el.getAttribute(attr) || '').split(/\s+/).filter(Boolean); }
    function setCount(n) { if (countEl) countEl.textContent = String(n); }

    function facets() {
      var list = cards();
      var catCounts = {}, matCounts = {};
      list.forEach(function (c) {
        tokens(c, 'data-cat').forEach(function (t) { if (CAT_LABELS[t]) catCounts[t] = (catCounts[t] || 0) + 1; });
        tokens(c, 'data-material').forEach(function (t) { if (MATERIAL_LABELS[t]) matCounts[t] = (matCounts[t] || 0) + 1; });
      });
      var cats = CAT_ORDER.filter(function (k) { return catCounts[k]; }).map(function (k) { return { id: k, label: CAT_LABELS[k], n: catCounts[k] }; });
      var mats = MATERIAL_ORDER.filter(function (k) { return matCounts[k]; }).map(function (k) { return { id: k, label: MATERIAL_LABELS[k], n: matCounts[k] }; });
      var prices = PRICE_DEFS.filter(function (b) {
        return list.some(function (c) { var p = parseFloat(c.getAttribute('data-price')) || 0; return p >= b.min && p < b.max; });
      });
      return { cats: cats, mats: mats, prices: prices };
    }

    function matches(c) {
      var catSel = Object.keys(state.cats).filter(function (k) { return state.cats[k]; });
      var matSel = Object.keys(state.mats).filter(function (k) { return state.mats[k]; });
      if (catSel.length) {
        var cc = tokens(c, 'data-cat');
        if (!catSel.some(function (k) { return cc.indexOf(k) !== -1; })) return false;
      }
      if (matSel.length) {
        var mm = tokens(c, 'data-material');
        if (!matSel.some(function (k) { return mm.indexOf(k) !== -1; })) return false;
      }
      if (state.price) {
        var p = parseFloat(c.getAttribute('data-price')) || 0;
        if (!(p >= state.price.min && p < state.price.max)) return false;
      }
      return true;
    }

    function resetChips() {
      document.querySelectorAll('[data-filter]').forEach(function (ch) {
        ch.classList.toggle('active', ch.getAttribute('data-filter') === 'all');
      });
    }

    function apply() {
      resetChips();
      var shown = 0;
      cards().forEach(function (c) {
        c.style.display = '';
        var ok = matches(c);
        c.classList.toggle('filter-hidden', !ok);
        if (ok) shown++;
      });
      setCount(shown);
      var applyBtn = panel && panel.querySelector('[data-fpanel-apply]');
      if (applyBtn) applyBtn.textContent = 'Show ' + shown + ' result' + (shown === 1 ? '' : 's');
      return shown;
    }

    function clearState() {
      state = { cats: {}, mats: {}, price: null };
      if (panel) {
        panel.querySelectorAll('input').forEach(function (i) { i.checked = i.getAttribute('data-price-opt') === 'any'; });
      }
    }

    function optionRow(type, id, label, n) {
      var attr = type === 'cat' ? 'data-cat-opt' : type === 'mat' ? 'data-mat-opt' : 'data-price-opt';
      var input = type === 'price' ? 'radio' : 'checkbox';
      var name = type === 'price' ? ' name="fprice"' : '';
      var nHtml = n != null ? '<span class="fopt__n">' + n + '</span>' : '';
      return '<label class="fopt"><input type="' + input + '"' + name + ' ' + attr + '="' + id + '"><span class="fopt__t">' + label + '</span>' + nHtml + '</label>';
    }
    function section(title, rows) {
      if (!rows) return '';
      return '<div class="fsec"><p class="fsec__h">' + title + '</p><div class="fsec__opts">' + rows + '</div></div>';
    }

    function build() {
      var f = facets();
      var catRows = f.cats.map(function (o) { return optionRow('cat', o.id, o.label, o.n); }).join('');
      var priceRows = optionRow('price', 'any', 'Any price', null) + f.prices.map(function (b) { return optionRow('price', b.id, b.label, null); }).join('');
      var matRows = f.mats.map(function (o) { return optionRow('mat', o.id, o.label, o.n); }).join('');

      panel = document.createElement('div');
      panel.className = 'fpanel';
      panel.setAttribute('data-fpanel', '');
      panel.hidden = true;
      panel.innerHTML =
        '<div class="fpanel__scrim" data-fpanel-close></div>' +
        '<aside class="fpanel__panel" role="dialog" aria-modal="true" aria-label="Filter products">' +
        '<div class="fpanel__head"><span class="fpanel__title">Filter</span>' +
        '<button class="fpanel__x" type="button" data-fpanel-close aria-label="Close filters">&times;</button></div>' +
        '<div class="fpanel__body">' + section('Category', catRows) + section('Price', priceRows) + section('Material', matRows) + '</div>' +
        '<div class="fpanel__foot">' +
        '<button type="button" class="fpanel__clear" data-fpanel-clear>Clear all</button>' +
        '<button type="button" class="btn btn--solid btn--pill" data-fpanel-apply>Show results</button>' +
        '</div></aside>';
      document.body.appendChild(panel);

      var anyPrice = panel.querySelector('[data-price-opt="any"]');
      if (anyPrice) anyPrice.checked = true;

      panel.addEventListener('change', function (e) {
        var t = e.target;
        if (t.hasAttribute('data-cat-opt')) state.cats[t.getAttribute('data-cat-opt')] = t.checked;
        else if (t.hasAttribute('data-mat-opt')) state.mats[t.getAttribute('data-mat-opt')] = t.checked;
        else if (t.hasAttribute('data-price-opt')) {
          var id = t.getAttribute('data-price-opt');
          state.price = id === 'any' ? null : PRICE_DEFS.filter(function (b) { return b.id === id; })[0] || null;
        }
        apply();
      });
      panel.addEventListener('click', function (e) {
        if (e.target.closest('[data-fpanel-close]')) close();
        else if (e.target.closest('[data-fpanel-clear]')) { clearState(); apply(); }
        else if (e.target.closest('[data-fpanel-apply]')) close();
      });
    }

    function open() {
      if (!panel) build();
      apply();
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!panel) return;
      panel.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { if (panel) panel.hidden = true; }, 300);
    }

    trigger.addEventListener('click', function (e) { e.preventDefault(); open(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel && !panel.hidden) close(); });

    document.querySelectorAll('[data-filter]').forEach(function (ch) {
      ch.addEventListener('click', function () {
        clearState();
        cards().forEach(function (c) { c.classList.remove('filter-hidden'); });
      });
    });
  }

  /* ---- PDP description: collapse "✦ Heading" sections into accordions ----
     Description HTML is a sequence of <hr>-separated blocks: an intro block
     (optional <h2>, tagline <p>, body <p>s), then one block per ✦ section,
     then trailing blocks (production note, shipping/returns line) with no
     heading. Only the tagline + first paragraph of the intro stay visible;
     ✦ blocks become accordion rows (styled like .promise__row, matching the
     homepage promise accordion) appended into the "Fine Details" group
     Liquid always renders (seeded with a Material & Sizing row, so the
     heading + at least one accordion show even for products with no ✦
     sections — e.g. Martini Studs). Trailing non-✦ blocks stay visible
     below the accordions since they're purchase-relevant (shipping,
     returns). */
  function initPdpDescription() {
    var desc = document.querySelector('[data-pdp-desc]');
    if (!desc) return;
    var nodes = Array.prototype.slice.call(desc.children);
    if (!nodes.length) return;

    var blocks = [[]];
    nodes.forEach(function (node) {
      if (node.tagName === 'HR') { blocks.push([]); }
      else { blocks[blocks.length - 1].push(node); }
    });

    var introBlock = blocks.shift();
    var introParas = introBlock.filter(function (n) { return n.tagName === 'P'; }).slice(0, 2);
    desc.innerHTML = '';
    introParas.forEach(function (p) { desc.appendChild(p); });
    if (!blocks.length) return;

    var accWrap = document.querySelector('[data-pdp-accordions]');
    var trailWrap = document.createElement('div');
    trailWrap.className = 'pdp__trailing';

    blocks.forEach(function (block, i) {
      var heading = block[0];
      if (heading && heading.tagName === 'H3' && heading.textContent.indexOf('✦') !== -1) {
        var title = heading.textContent.replace('✦', '').trim();
        var btnId = 'pdpacc-' + i;
        var panelId = 'pdppanel-' + i;
        var row = document.createElement('div');
        row.className = 'promise__row';
        row.setAttribute('data-accordion-row', '');
        row.innerHTML =
          '<button type="button" class="promise__sum" id="' + btnId + '" aria-expanded="false" aria-controls="' + panelId + '" data-accordion-toggle>' +
            '<span class="promise__sumrow"><span class="h3">' + title + '</span><span class="promise__icon" aria-hidden="true"></span></span>' +
          '</button>' +
          '<div class="promise__panel" id="' + panelId + '" role="region" aria-labelledby="' + btnId + '" data-accordion-panel style="max-height:0px;"></div>';
        var panel = row.querySelector('[data-accordion-panel]');
        block.slice(1).forEach(function (n) {
          if (n.tagName === 'P') n.classList.add('fine');
          panel.appendChild(n);
        });
        if (accWrap) accWrap.appendChild(row);

        row.querySelector('[data-accordion-toggle]').addEventListener('click', function () {
          var open = row.classList.toggle('open');
          this.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        });
      } else {
        block.forEach(function (n) {
          if (n.tagName === 'P') n.classList.add('fine');
          trailWrap.appendChild(n);
        });
      }
    });

    /* append (not insert right after the intro) so these land below the
       whole form — price, availability note and the Add to Bag button
       all stay together right under the intro, not buried under seven
       collapsed accordions */
    var headEl = desc.parentElement;
    if (trailWrap.children.length) headEl.appendChild(trailWrap);
  }

  /* Every PDP must show at least one Fine Details row. initPdpDescription()
     only adds rows when the product's description has ✦-marked sections, so
     a product with a plain description (or no description at all) would
     otherwise leave the accordions container empty. Runs after
     initPdpDescription and checks the container directly rather than
     threading a flag through its several early-returns, so it's correct
     regardless of which one fired. */
  function initPdpDefaultDetails() {
    var accWrap = document.querySelector('[data-pdp-accordions]');
    if (!accWrap || accWrap.children.length) return;
    var btnId = 'pdpacc-default';
    var panelId = 'pdppanel-default';
    var row = document.createElement('div');
    row.className = 'promise__row';
    row.setAttribute('data-accordion-row', '');
    row.innerHTML =
      '<button type="button" class="promise__sum" id="' + btnId + '" aria-expanded="false" aria-controls="' + panelId + '" data-accordion-toggle>' +
        '<span class="promise__sumrow"><span class="h3">Details</span><span class="promise__icon" aria-hidden="true"></span></span>' +
      '</button>' +
      '<div class="promise__panel" id="' + panelId + '" role="region" aria-labelledby="' + btnId + '" data-accordion-panel style="max-height:0px;">' +
        '<ul>' +
          '<li><strong>Materials:</strong> Each AVRA piece is made entirely of solid 14k gold and diamonds.</li>' +
          '<li><strong>Clarity:</strong> VS&ndash;VVS</li>' +
          '<li><strong>Color:</strong> D&ndash;E&ndash;F</li>' +
        '</ul>' +
      '</div>';
    accWrap.appendChild(row);
    row.querySelector('[data-accordion-toggle]').addEventListener('click', function () {
      var panel = row.querySelector('[data-accordion-panel]');
      var open = row.classList.toggle('open');
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    });
  }

  /* ---- Send a hint: split form with a live-updating preview card.
     Ported from assets/avra-legacy.js (which matches v0-source's product.html
     + avra.js exactly) — that script isn't loaded by this theme, so the
     modal markup + button existed in CSS/HTML history but the wiring never
     shipped. No real backend can send an arbitrary email between two people
     here (no custom app), so — matching the original — "sending" is a
     client-side confirmation state, same pattern as this theme's other
     no-backend forms. ---- */
  function initHint() {
    var modal = document.querySelector('[data-hint-modal]');
    var openers = document.querySelectorAll('[data-hint]');
    if (!modal || !openers.length) return;
    var form = modal.querySelector('[data-hint-form]');
    var yourName = modal.querySelector('[data-hint-yourname]');
    var rcvrName = modal.querySelector('[data-hint-rcvrname]');
    var rcvrEmail = modal.querySelector('[data-hint-rcvremail]');
    var msg = modal.querySelector('[data-hint-msg]');
    var sendBtn = modal.querySelector('[data-hint-sendbtn]');
    var done = modal.querySelector('[data-hint-done]');
    var card = modal.querySelector('[data-hint-card]');

    var pvRcvr = modal.querySelector('[data-hint-pv-rcvr]');
    var pvName = modal.querySelector('[data-hint-pv-name]');
    var pvName2 = modal.querySelector('[data-hint-pv-name2]');
    var pvMsg = modal.querySelector('[data-hint-pv-msg]');
    var pvProd = modal.querySelector('[data-hint-pv-prod]');
    var pvMaterial = modal.querySelector('[data-hint-pv-material]');

    var pdpName = document.querySelector('[data-pdp-name]');
    var pdpSub = document.querySelector('[data-pdp-sub]');
    var pdpMaterial = document.querySelector('[data-pdp-material]');
    var pdpImg = document.querySelector('#pdp-media-img');
    var hintImg = modal.querySelector('.hint__photo img, .hint__photo image-slot');

    function setText(el, val) { if (el) el.textContent = val; }

    function syncPhoto() {
      if (!pdpImg || !hintImg) return;
      if (hintImg.tagName === 'IMG') hintImg.src = pdpImg.src;
      else {
        var img = hintImg.querySelector('img');
        if (img) img.src = pdpImg.src;
      }
    }

    function syncPreview() {
      var yn = (yourName && yourName.value.trim()) || '';
      var rn = (rcvrName && rcvrName.value.trim()) || '';
      var m = (msg && msg.value.trim()) || '';
      setText(pvRcvr, rn);
      setText(pvName, yn);
      setText(pvName2, yn);
      setText(pvMsg, m);
      if (sendBtn) sendBtn.textContent = rn ? 'Send to ' + rn : 'Send to';
    }

    function syncProduct() {
      if (pvProd && pdpName) pvProd.textContent = pdpName.textContent.trim();
      if (pvMaterial) {
        var mat = pdpMaterial ? pdpMaterial.textContent.trim() : '14K Solid Gold';
        var d = pdpSub ? pdpSub.textContent.trim() : '';
        pvMaterial.textContent = (d ? d + ' · ' : '') + 'Material: ' + mat;
      }
    }

    function open() {
      syncProduct();
      syncPhoto();
      syncPreview();
      if (done) done.hidden = true;
      if (card) card.style.display = '';
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (yourName) yourName.focus(); }, 90);
    }
    function close() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-hint-close]').forEach(function (c) { c.addEventListener('click', close); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });

    [yourName, rcvrName, msg].forEach(function (el) {
      if (el) el.addEventListener('input', syncPreview);
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (rcvrEmail && !rcvrEmail.value.trim()) { rcvrEmail.focus(); return; }
      if (done) done.hidden = false;
      setTimeout(close, 2400);
      setTimeout(function () {
        if (form) form.reset();
        syncPreview();
        if (done) done.hidden = true;
      }, 2800);
    });
  }

  /* ---- PDP "pairs beautifully" recommendations ---- */
  function initPdpRecommendations() {
    var section = document.querySelector('[data-pdp-recs]');
    if (!section) return;
    var productId = section.getAttribute('data-pdp-recs');
    var track = section.querySelector('[data-pdp-recs-track]');
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) { return p.available; });
        if (!products.length || !track) return;
        track.innerHTML = products.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]);
          var price = p.price_varies ? 'From ' + money(p.price) : money(p.price);
          return (
            '<article class="prod">' +
              '<a href="' + p.url + '" class="prod__media">' +
                '<image-slot>' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</image-slot>' +
                '<button type="button" class="prod__quick" data-quick-add="' + p.variants[0].id + '" onclick="event.preventDefault();">Add to bag</button>' +
              '</a>' +
              '<a href="' + p.url + '" class="prod__info">' +
                '<span class="prod__name">' + p.title + '</span>' +
                '<span class="prod__price">' + price + '</span>' +
              '</a>' +
            '</article>'
          );
        }).join('');
        section.hidden = false;
        updateCarrowState(section);
        initCarouselDots(section);
      })
      .catch(function () {});
  }

  /* ---- welcome popup (once per session) ---- */
  function initWelcome() {
    var pop = document.querySelector('[data-welcome]');
    if (!pop) return;
    var KEY = 'avra:welcomeShown';
    try {
      if (sessionStorage.getItem(KEY)) return;
    } catch (e) { return; }
    setTimeout(function () {
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('open'); });
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    }, 900);
    pop.querySelectorAll('[data-welcome-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        pop.classList.remove('open');
        setTimeout(function () { pop.hidden = true; }, 400);
      });
    });
  }

  /* ---- PDP image gallery: click a thumbnail, swap the main image ---- */
  function initPdpGallery() {
    var mediaImg = document.getElementById('pdp-media-img');
    var thumbs = document.querySelectorAll('[data-pdp-thumbs] .pdp__thumb');
    if (!mediaImg || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-thumb-src');
        if (!src) return;
        mediaImg.removeAttribute('srcset'); mediaImg.removeAttribute('sizes'); mediaImg.src = src;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    [initReveal, initHeader, initMega, initDrawer, initAccordion, initCarousels, initFavorites, initFavDrawer, initCart, initSearch, initWelcome, initPdpDescription, initPdpDefaultDetails, initPdpGallery, initHint, initPdpRecommendations, initCollectionChips, initFilterPanel]
      .forEach(function (fn) { try { fn(); } catch (e) { /* one failing module should not break the rest */ } });
  });
})();
